/**
 * 工作流素材 URL / fileType 判断（后端 fileType 可能不准，优先按 URL 后缀识别）
 */

const VIDEO_EXT = new Set([
  'mp4', 'webm', 'ogg', 'ogv', 'mov', 'm4v', 'avi', 'mkv', '3gp', 'flv', 'wmv', 'mpeg', 'mpg',
])

const IMAGE_EXT = new Set([
  'jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'ico', 'avif',
])

/** 取 URL 路径中最后一个路径段的扩展名（不含点，小写），忽略 query/hash */
export function getUrlPathExtension(url) {
  if (!url || typeof url !== 'string') return ''
  const trimmed = url.trim()
  try {
    const u = new URL(trimmed)
    const seg = u.pathname.split('/').pop() || ''
    const i = seg.lastIndexOf('.')
    return i >= 0 ? seg.slice(i + 1).toLowerCase() : ''
  } catch {
    const path = trimmed.split('?')[0].split('#')[0]
    const seg = path.split('/').pop() || ''
    const i = seg.lastIndexOf('.')
    return i >= 0 ? seg.slice(i + 1).toLowerCase() : ''
  }
}

/**
 * 仅根据 URL 判断是否为视频：true / false / null（无法从后缀判断）
 */
export function isVideoUrl(url) {
  const ext = getUrlPathExtension(url)
  if (VIDEO_EXT.has(ext)) return true
  if (IMAGE_EXT.has(ext)) return false
  return null
}

/**
 * 是否按视频展示：先 URL 后缀，再 fileType（0 视频 1 图片），否则按非视频
 */
export function isWorkflowFileVideo(file) {
  if (!file) return false
  const url = String(file.fileUrl ?? '').trim()
  const byUrl = isVideoUrl(url)
  if (byUrl === true) return true
  if (byUrl === false) return false
  const ft = String(file.fileType ?? '').trim()
  if (ft === '0') return true
  if (ft === '1') return false
  return false
}

function isHttpUrl(s) {
  return typeof s === 'string' && /^https?:\/\//i.test(s.trim())
}

/** 列表封面：优先图片 URL，其次视频，再任意素材 */
export function pickCoverFromWorkflowFiles(files) {
  if (!Array.isArray(files) || !files.length) return ''
  const firstImg = files.find((f) => f && f.fileUrl && isHttpUrl(String(f.fileUrl)) && !isWorkflowFileVideo(f))
  if (firstImg) return String(firstImg.fileUrl).trim()
  const firstVid = files.find((f) => f && f.fileUrl && isHttpUrl(String(f.fileUrl)) && isWorkflowFileVideo(f))
  if (firstVid) return String(firstVid.fileUrl).trim()
  const any = files.find((f) => f && f.fileUrl && isHttpUrl(String(f.fileUrl)))
  return any ? String(any.fileUrl).trim() : ''
}

/** 列表卡片悬停：workflowFiles[0]，视频/图片由 URL 后缀与 fileType 综合判断 */
export function firstWorkflowFileHoverMedia(files) {
  if (!Array.isArray(files) || !files.length) return null
  const f = files[0]
  if (!f || f.fileUrl == null) return null
  const url = String(f.fileUrl).trim()
  if (!isHttpUrl(url)) return null
  return { url, isVideo: isWorkflowFileVideo(f) }
}
